<template>
  <ul class="publicListWrap">
    <li
      v-for="(v, i) in list"
      :key="i"
      :class="$parent.active == i ? 'activeLi' : ''"
      @click="changeActive(v, i)"
    >
      <p>{{ v.title }}</p>
    </li>
  </ul>
</template>

<script>
export default {
  props: ["list"],
  data() {
    return {};
  },
  methods: {
    changeActive(item, index) {
      this.$parent.active = index;
      this.$emit("getActiveTitle", { item, index });
    },
  },
  watch: {},
  created() {},
};
</script>

<style lang="scss" scoped>
.publicListWrap {
  width: 90%;
  height: 100%;
  margin: 0 auto;
  li {
    height: 50px;
    border-bottom: 1px solid #dcdfe6;
    margin-left: 20px;
    cursor: pointer;
    p {
      line-height: 49px;
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  li:nth-child(1) {
    padding-top: 20px;
  }
  .activeLi {
    color: #3579ff;
  }
}
</style>